import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';
import { OrderDesktopComponent } from '@app/pages/pages-auth/customer-order/order-desktop/order-desktop.component';
import { OrderMobileComponent } from '@app/pages/pages-auth/customer-order/order-mobile/order-mobile.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-auth-customer-order',
  standalone: true,
  imports: [CommonModule, OrderDesktopComponent, OrderMobileComponent],
  templateUrl: './auth-customer-order.component.html',
  styleUrl: './auth-customer-order.component.scss',
})
export class AuthCustomerOrderComponent implements OnInit {
  screenSize!: string;

  private routeSub!: Subscription;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // feature - auto-login from public order page to auth order page

    // if (!!this.authService.user.value) {
    //   this.routeSub = this.route.params.subscribe((params) => {
    //     const customerOrderId: string = params['id'];

    //     this.router.navigate(['/customer/customer-order/' + customerOrderId]);
    //   });
    // }

    this.screenSize = this.route.snapshot.data['screenSize'];
  }
}
